define("settings/components/profiles/industry", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper">
    <label>
      {{t "account.social_accounts.industry.header"}}
      <span class="u--text--hair">
        {{@industry}}
      </span>
    </label>
    <div class="u--clearfix">
      <label class="u--p__t__xs">
        {{t "account.social_accounts.industry.business_type"}}
        <span class="u--text--hair">
          {{@businessModel}}
        </span>
      </label>
      {{#if @showPartnershipsOptIn}}
        <Shared::Ui::Button
          @onClick={{@goToPartnerships}}
          @size="small"
          @text={{t "account.social_accounts.industry.opt_in"}}
          class="u--float--right"
        />
      {{/if}}
    </div>
    <p class="o--form__helpText">
      {{t "account.social_accounts.industry.body"}}
    </p>
    {{! Note: We are currently doing validation on the FE, however this may need to change to be validated on the BE
    if self-cat is brought to mobile }}
    {{#if @canChangeIndustry}}
      <p class="o--form__helpText">
        {{t "account.social_accounts.industry.footer"}}
        <Shared::link
          @href="#"
          @text={{t "account.social_accounts.industry.footer_link"}}
          data-test-id="industry-footer-link"
          {{on "click" @promptToEditIndustry}}
        />
      </p>
    {{else}}
      <p class="o--form__helpText">
        {{html-safe
          (t
            "account.social_accounts.industry.confirm_modal.unavailable"
            industryChangeFrequencyInDays=@industryChangeFrequencyInDays
          )
        }}{{@industryNextChangeTime}}
      </p>
    {{/if}}
  </div>
  */
  {
    "id": "2aWxjmt/",
    "block": "[[[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"account.social_accounts.industry.header\"],null]],[1,\"\\n    \"],[10,1],[14,0,\"u--text--hair\"],[12],[1,\"\\n      \"],[1,[30,1]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--clearfix\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"u--p__t__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.social_accounts.industry.business_type\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--text--hair\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[8,[39,2],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@size\",\"@text\"],[[30,4],\"small\",[28,[37,0],[\"account.social_accounts.industry.opt_in\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"o--form__helpText\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"account.social_accounts.industry.body\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[10,2],[14,0,\"o--form__helpText\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.social_accounts.industry.footer\"],null]],[1,\"\\n      \"],[8,[39,3],[[24,\"data-test-id\",\"industry-footer-link\"],[4,[38,4],[\"click\",[30,6]],null]],[[\"@href\",\"@text\"],[\"#\",[28,[37,0],[\"account.social_accounts.industry.footer_link\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,2],[14,0,\"o--form__helpText\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[[28,[37,0],[\"account.social_accounts.industry.confirm_modal.unavailable\"],[[\"industryChangeFrequencyInDays\"],[[30,7]]]]],null]],[1,[30,8]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"@industry\",\"@businessModel\",\"@showPartnershipsOptIn\",\"@goToPartnerships\",\"@canChangeIndustry\",\"@promptToEditIndustry\",\"@industryChangeFrequencyInDays\",\"@industryNextChangeTime\"],false,[\"t\",\"if\",\"shared/ui/button\",\"shared/link\",\"on\",\"html-safe\"]]",
    "moduleName": "settings/components/profiles/industry.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});